import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import ClickOutside from 'vuetify/lib/directives/click-outside';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VNavigationDrawer, {
    directives: [{
      def: ClickOutside,
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickOutsideDrawer,
      expression: "clickOutsideDrawer"
    }],
    attrs: {
      fixed: "",
      bottom: "",
      right: "",
      width: _vm.drawerWidth,
      temporary: ""
    },
    model: {
      value: _vm.drawer,
      callback: function callback($$v) {
        _vm.drawer = $$v;
      },
      expression: "drawer"
    }
  }, [_c("div", {
    staticClass: "drawer"
  }, [_c("section", {
    staticClass: "drawer-header"
  }, [_c("div", {
    staticClass: "drawer-title"
  }, [_c(VBtn, {
    staticClass: "primary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      dark: ""
    }
  }, [_vm._v("mdi-close")])], 1), _c("h2", [_vm._v("Send payment link")])], 1)]), _c(VStepper, {
    key: _vm.steps.length,
    attrs: {
      vertical: ""
    },
    model: {
      value: _vm.currentStep,
      callback: function callback($$v) {
        _vm.currentStep = $$v;
      },
      expression: "currentStep"
    }
  }, _vm._l(_vm.steps, function (step) {
    return _c("div", {
      key: "step_".concat(step.id)
    }, [_c(VStepperStep, {
      attrs: {
        step: step.id,
        complete: _vm.currentStep > step.id,
        rules: step.rules,
        editable: ""
      }
    }, [_vm._v(" " + _vm._s(step.title) + " "), _c("small", [_vm._v(_vm._s(step.inf))])]), step.key === "link" ? _c(VStepperContent, {
      attrs: {
        step: step.id
      }
    }, [_c("div", [_c(VAutocomplete, {
      staticClass: "required",
      attrs: {
        items: _vm.users,
        "item-value": "id_user",
        "item-text": "full_name",
        label: "Send email to",
        "hide-details": "auto",
        readonly: !!_vm.paymentLink.id
      },
      model: {
        value: _vm.paymentLink.userId,
        callback: function callback($$v) {
          _vm.$set(_vm.paymentLink, "userId", $$v);
        },
        expression: "paymentLink.userId"
      }
    })], 1), _c("div", [_c(VTextField, {
      staticClass: "required",
      attrs: {
        label: "Amount to pay (".concat(_vm.paymentLink.currency, ")"),
        readonly: true,
        placeholder: "0.00",
        type: "number",
        min: "1",
        required: "",
        max: _vm.maxAmount,
        rules: [_vm.rules.mustBeGreaterThan0],
        "hide-details": "auto"
      },
      model: {
        value: _vm.paymentLink.amount,
        callback: function callback($$v) {
          _vm.$set(_vm.paymentLink, "amount", $$v);
        },
        expression: "paymentLink.amount"
      }
    })], 1), _vm.paymentLink.stripeUrl ? _c("div", {
      staticClass: "stripe_link-container"
    }, [_c(VTextField, {
      attrs: {
        label: "Link",
        readonly: true,
        "hide-details": "auto"
      },
      model: {
        value: _vm.paymentLink.stripeUrl,
        callback: function callback($$v) {
          _vm.$set(_vm.paymentLink, "stripeUrl", $$v);
        },
        expression: "paymentLink.stripeUrl"
      }
    }), _c("div", {
      staticClass: "tripe_link_code-icons"
    }, [_c(VTooltip, {
      attrs: {
        top: ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref) {
          var on = _ref.on,
            attrs = _ref.attrs;
          return [_c(VIcon, _vm._g(_vm._b({
            attrs: {
              small: ""
            },
            on: {
              click: function click($event) {
                return _vm.copyToClipboard(_vm.paymentLink.stripeUrl);
              }
            }
          }, "v-icon", attrs, false), on), [_vm._v(" far fa-clipboard ")])];
        }
      }], null, true)
    }, [!_vm.isCopyingToClipboard ? _c("span", [_vm._v("Copy to clipboard")]) : _vm._e(), _vm.isCopyingToClipboard ? _c("div", [_c(VIcon, {
      staticStyle: {
        color: "green"
      }
    }, [_vm._v("mdi-check")]), _vm._v(" Copied ")], 1) : _vm._e()])], 1)], 1) : _vm._e(), !_vm.paymentLink.stripeUrl ? _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary",
        disabled: _vm.paymentLink.stripeUrl,
        loading: _vm.isLinkCreating,
        "data-cy": "step-synthesis-continue-btn"
      },
      on: {
        click: function click($event) {
          return _vm.createPaymentLink();
        }
      }
    }, [_vm._v(" Generate ")])], 1) : _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary",
        "data-cy": "step-mail-continue-btn"
      },
      on: {
        click: _vm.confirmStep
      }
    }, [_vm._v(" Continue ")])], 1)]) : _vm._e(), step.key === "synthesis" ? _c(VStepperContent, {
      attrs: {
        step: step.id
      }
    }, [_vm.isInvalidMainForm ? _c("div", {
      staticClass: "errorLabel text-sm"
    }, _vm._l(_vm.errorsMainForm, function (error, i) {
      return _c("div", {
        key: "mainError-".concat(i)
      }, [_vm._v(" " + _vm._s(error) + " ")]);
    }), 0) : _c("div", {
      staticClass: "text-left pb-2"
    }, [_c("div", {
      staticClass: "text-bold"
    }, [_c("div", [_vm._v("An email will be sent to the customer, with the stripe payment link.")]), _c("div", [_vm._v(" When the customer complete the transaction, the order status will be automatically updated on platform. ")])]), _c("div", {
      staticClass: "mt-4"
    }, [_vm._v(" Link "), _c("strong", [_vm._v(" " + _vm._s(_vm.paymentLink.stripeUrl) + " ")])])]), _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary",
        loading: _vm.isValidating,
        disabled: _vm.isInvalidMainForm,
        "data-cy": "step-synthesis-continue-btn"
      },
      on: {
        click: _vm.validateMain
      }
    }, [_vm._v(" " + _vm._s("Send payment link") + " ")])], 1)]) : _vm._e()], 1);
  }), 0)], 1), _c("Confirm", {
    ref: "confirm"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };